import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { motion } from 'framer-motion';

const SuccessDialog = ({ open, onClose, message }) => {
  const { t } = useTranslation();
  const MotionBox = motion.div;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { 
          borderRadius: 2,
          maxWidth: '400px',
          width: '100%'
        }
      }}
    >
      <DialogContent>
        <MotionBox
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            py: 2
          }}
        >
          <MotionBox
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.3 }}
          >
            <CheckCircle 
              sx={{ 
                fontSize: 80, 
                color: 'success.main',
                mb: 2
              }} 
            />
          </MotionBox>
          
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600 }}>
            {t('common.success')}!
          </Typography>
          
          <Typography align="center" variant="body1" color="text.secondary">
            {message || t('success.operationCompleted')}
          </Typography>
        </MotionBox>
      </DialogContent>
      
      <DialogActions sx={{ pb: 3, px: 3, justifyContent: 'center' }}>
        <Button 
          onClick={onClose}
          variant="contained"
          sx={{ 
            minWidth: 120,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a71d6 0%, #6a4292 100%)'
            }
          }}
        >
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;